import UAParser from 'ua-parser-js';

import { isAppleMobile } from '@utils/dom.ts';

export function initFavicons(path: string) {
  const { browser, os } = new UAParser().getResult();
  // Safari does not reliably pick up favicon links inserted after page load.
  if (browser.name?.includes('Safari')) {
    return;
  }
  const isIOS = os.name === 'iOS' || isAppleMobile();

  // iOS added SVG favicons in version 26; assume other major browsers are current.
  const supportsSvg = isIOS
    ? Number.parseInt(os.version ?? '', 10) >= 26
    : /(?:Chrome|Chromium|Firefox)\//.test(navigator.userAgent);

  const addIcon = (rel: string, name: string, type: string, sizes = '') => {
    const link = document.createElement('link');
    link.rel = rel;
    link.type = type;
    link.setAttribute('sizes', sizes);
    link.href = path + name;
    document.head.appendChild(link);
  };

  if (supportsSvg) {
    addIcon('icon', 'favicon.svg', 'image/svg+xml', 'any');
  } else {
    addIcon('icon', 'favicon.png', 'image/png');
  }

  if (isIOS) {
    addIcon('apple-touch-icon', 'favicon-152.png', 'image/png');
  }
}
